import { createFormHook } from "@tanstack/react-form"
import { ImageDisplay } from "../components/image-display"
import { NumberField } from "../components/number-field"
import { ProgressBar } from "../components/progress-bar"
import {
  SelectableCard,
  SelectableCardDescription,
  SelectableCardLabel,
} from "../components/selectable-card"
import { ServiceProposalDependencies } from "../components/service-proposal-dependencies"
import { ServiceProposalFeeCard } from "../components/service-proposal-fee-card"
import { ServiceProposalManualActionProductChoicesField } from "../components/service-proposal-manual-action-product-choices-field"
import { ServiceProposalManualActionsField } from "../components/service-proposal-manual-actions-field"
import { ServiceProposalPackageCard } from "../components/service-proposal-package-card"
import { ServiceProposalPackageField } from "../components/service-proposal-package-field"
import { ServiceProposalPackagePartActionsField } from "../components/service-proposal-package-part-actions-field"
import { ServiceProposalPackageWashField } from "../components/service-proposal-package-wash-field"
import { ServiceProposalPartActionProductChoicesField } from "../components/service-proposal-part-action-product-choices-field"
import { ServiceProposalPartActionsField } from "../components/service-proposal-part-actions-field"
import { ServiceProposalProductChoicesField } from "../components/service-proposal-product-choices-field"
import { ServiceProposalWashAlternativesField } from "../components/service-proposal-wash-alternatives-field"
import { ServiceProposalWashField } from "../components/service-proposal-wash-field"
import { SubmitButton } from "../components/submit-button"
import { TextField } from "../components/text-field"
import { fieldContext, formContext } from "./form-contexts"

export { fieldContext, formContext, useFieldContext } from "./form-contexts"

export const { useAppForm } = createFormHook({
  fieldComponents: {
    TextField,
    NumberField,
    ServiceProposalPartActionsField,
    ServiceProposalManualActionsField,
    ServiceProposalManualActionProductChoicesField,
    ServiceProposalPartActionProductChoicesField,
    ServiceProposalProductChoicesField,
    ServiceProposalWashField,
    ServiceProposalWashAlternativesField,
    ServiceProposalPackageField,
    ServiceProposalPackagePartActionsField,
    ServiceProposalPackageWashField,
    ServiceProposalFeeCard,
    ServiceProposalPackageCard,
    SelectableCard,
    ProgressBar,
    ImageDisplay,
  },
  formComponents: {
    SubmitButton,
    ServiceProposalDependencies,
    SelectableCardLabel,
    SelectableCardDescription,
  },
  fieldContext,
  formContext,
})
